import { createPredicate } from './condition.js';
import { ExternalCustomEvents } from './utils.js';

var debug = false;
var initialized = false;
var loaderScript = null;
var initScript = null;
var PROVIDER = 'GoogleAds';
var log = function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    if (!debug) {
        return;
    }
    // eslint-disable-next-line no-console
    console.info.apply(console, ['[ga]'].concat(args));
};
function initializeGoogleAds(brandId, tagId, options) {
    if (!initialized && brandId && tagId) {
        initialized = true;
        loaderScript = document.createElement('script');
        loaderScript.async = true;
        loaderScript.type = 'text/javascript';
        loaderScript.src = "https://www.googletagmanager.com/gtag/js?id=".concat(tagId);
        document.head.appendChild(loaderScript);
        initScript = document.createElement('script');
        initScript.innerHTML = "window.dataLayer = window.dataLayer || [];\n        function gtag(){dataLayer.push(arguments);}\n        gtag('js', new Date());\n        gtag('config', '".concat(tagId, "' ").concat(options ? ',' + JSON.stringify(options) : '', ");");
        document.head.appendChild(initScript);
    }
}
function reportConversion(_a) {
    var googleTagId = _a.googleTagId, conversionId = _a.conversionId, value = _a.value, currency = _a.currency;
    window.gtag('event', 'conversion', {
        send_to: "".concat(googleTagId, "/").concat(conversionId),
        value: value,
        currency: currency,
    });
    return false;
}
var googleTags = {
    enableDebug: function () {
        debug = true;
    },
    track: function (brandId, pixels, eventName, eventPayload) {
        pixels = pixels === null || pixels === void 0 ? void 0 : pixels.filter(function (item) { return item.pixelProvider === PROVIDER; });
        if (!(pixels === null || pixels === void 0 ? void 0 : pixels.length)) {
            return;
        }
        pixels.forEach(function (pixel) {
            if (pixel === null || pixel === void 0 ? void 0 : pixel.pixelId) {
                if (pixel.eventFilter) {
                    var predicate = createPredicate(pixel.eventFilter);
                    if (!predicate(eventPayload)) {
                        log('eventFilter not matched', pixel.eventFilter, pixel === null || pixel === void 0 ? void 0 : pixel.pixelId, eventName, eventPayload);
                        return;
                    }
                }
                var conversionId = '';
                if (eventName === ExternalCustomEvents.BCPageView) {
                    conversionId = pixel === null || pixel === void 0 ? void 0 : pixel.pageViewConversionId;
                }
                else if (eventName === ExternalCustomEvents.BCBuyBoxClick) {
                    conversionId = pixel === null || pixel === void 0 ? void 0 : pixel.buyBoxClickConversionId;
                }
                if (conversionId) {
                    initializeGoogleAds(brandId, pixel === null || pixel === void 0 ? void 0 : pixel.pixelId, pixel === null || pixel === void 0 ? void 0 : pixel.pixelOptions);
                    reportConversion({
                        googleTagId: pixel.pixelId,
                        conversionId: conversionId,
                        value: eventPayload === null || eventPayload === void 0 ? void 0 : eventPayload.retailPrice,
                        currency: 'USD',
                    });
                    log('conversion reported', conversionId, eventName, eventPayload);
                }
                else {
                    log('conversionId not found', eventName, eventPayload);
                }
            }
        });
    },
};

export { googleTags as default };
//# sourceMappingURL=google.js.map
